import { render, staticRenderFns } from "./ExceptionalGiftExperience.vue?vue&type=template&id=53c107da&scoped=true&"
import script from "./ExceptionalGiftExperience.vue?vue&type=script&lang=js&"
export * from "./ExceptionalGiftExperience.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionalGiftExperience.vue?vue&type=style&index=0&id=53c107da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c107da",
  null
  
)

export default component.exports